<template>
  <div class="client-page">
    <div class="client-content">
      <div class="client-box">
        <div class="client-title">客户中心</div>
        <div class="client-text">高效管理和组织您的企业客户资源。</div>
      </div>
      <div class="client-display">
        <el-date-picker v-model="dateRange" type="daterange" range-separator="~" start-placeholder="开始日期"
          end-placeholder="结束日期" value-format="yyyy-MM-dd" format="yyyy-MM-dd" :picker-options="pickerOptions"
          class="calendar-date-picker" />
        <div class="history-export" @click="showHistory">
          <i class="el-icon-time iconTime"></i>
          <div class="export-text exportText">历史记录</div>
        </div>
      </div>
    </div>

    <div class="filter-data">
      <div class="filter-box">
        <div class="filter-content">
          <div class="filter-title">筛选条件</div>
          <div class="filter-btn" @click="handleCustomerReset">重置</div>
        </div>
        <div class="filter-time">创建时间</div>
        <el-select v-model="timeRange" placeholder="请选择时间范围" class="filter-input">
          <el-option label="最近 一月" value="30d" />
          <el-option label="最近 三个月" value="90d" />
          <el-option label="最近一年" value="1y" />
        </el-select>
        <div class="filter-name">姓名</div>
        <el-input v-model="userName" placeholder="请输入姓名" class="filter-input" />
        <div class="filter-text">备注</div>
        <el-input type="textarea" :rows="5" placeholder="请输入内容" v-model="showNickName" />
        <!-- 按钮搜索 -->
        <el-button type="primary" @click="handleCustomerSearch" style="width: 100%;margin-top: 10px;">搜索</el-button>
      </div>

      <div class="stats-bar-box">
        <div class="stats-bar">
          <div class="stats-content">
            <img class="stats-img" src="@/assets/image/sorting.png" />
            <div class="stats-text">排序:最新创建</div>
            <img class="stats-icon" src="@/assets/image/series.png" />
            <div class="stats-image">自定义列</div>
          </div>
          <div class="stats-total">{{ totalCustomerText }}</div>
        </div>
        <el-table :data="pagedTableData" v-loading="customerTableLoading" element-loading-text="加载中...">
          <el-table-column prop="name" label="姓名">
            <template slot-scope="scope">
              <div class="stats-image-box">
                <img class="stats-headImage" :src="scope.row.headImage" />
                <div>{{ scope.row.name }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="nickname" label="ID / 昵称">
            <template slot-scope="scope">
              <div class="stats-nickname">昵称: {{ scope.row.nickname }}</div>
              <div class="stats-nickID">ID: {{ scope.row.nickID }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="showNickName" label="备注">
            <template slot-scope="scope">
              <div class="stats-showNickName">{{ scope.row.showNickName }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="creationDate" label="创建日期">
            <template slot-scope="{ row }">
              <div class="creationDate">{{ row.creationDate }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="fettle" label="状态">
            <template slot-scope="{ row }">
              <div class="stats-line-box">
                <div class="stats-line" :class="{ 'status-offline': !row.online, 'status-online': row.online }"></div>
                <div class="stats-fettle" :class="{ 'text-offline': !row.online, 'text-online': row.online }">
                  {{ row.online ? "活跃" : "未活跃" }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="{ row }">
              <i class="el-icon-download iconDownload" @click="exportHistory(row.id)" />
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <div>{{ pageInfoText }}</div>
          <el-pagination background layout="prev, pager, next" :current-page="customerPageNum"
            :page-size="customerPageSize" :total="customerTotal" @current-change="handleCustomerPageChange" />
        </div>
      </div>
    </div>

    <el-dialog :visible.sync="exportList" width="30%" :show-close="false">
      <div class="export-title">导出申请</div>
      <div class="export-txt">详细说明</div>
      <el-input type="textarea" :rows="5" placeholder="请输入请求说明" v-model="exportTextarea" />
      <div class="illustrateBox">
        <div class="illustrate-text">向管理发送导出申请</div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="closureDialog">取 消</el-button>
          <el-button type="primary" @click="ExportConfirm">确 定</el-button>
        </span>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="outerVisible" :show-close="false" width="90%" margin-top="20px !important">
      <div class="history-close">
        <div class="close-box">
          <img class="close-icon" src="@/assets/image/close.png" />
          <div class="close-title">历史记录</div>
        </div>
        <i class="el-icon-close" v-if="outerVisible" @click="closeHistory" style="cursor: pointer; font-size: 25px" />
      </div>
      <div class="history-search">
        <div class="work-order">
          <div v-for="item in workOrderTypes" :key="item.value" class="work-order-title"
            :class="{ workTitle: activeWorkOrder === item.value }" @click="setActiveWorkOrder(item.value)">
            {{ item.label }}
          </div>
        </div>
        <div class="history-search-box">
          <el-date-picker v-model="dialogDateRange" type="daterange" range-separator="~" start-placeholder="开始日期"
            end-placeholder="结束日期" value-format="yyyy-MM-dd" format="yyyy-MM-dd" :picker-options="pickerOptions"
            class="calendar-date-picker" />
          <el-input class="search-input" prefix-icon="el-icon-search" v-model="searchInput" placeholder="搜索工单编号" />
        </div>
      </div>
      <el-table :data="pagedData" style="width: 100%">
        <el-table-column prop="name" label="申请人" />
        <el-table-column prop="serialNumber" label="工单编号" />
        <el-table-column prop="text" label="请求内容" />
        <el-table-column prop="time" label="提交时间" />
        <el-table-column prop="btn" label="当前状态">
          <template slot-scope="scope">
            <div :class="getStatusClass(scope.row.btn)" class="status-tag">
              {{ scope.row.btn }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="operate" label="操作">
          <template slot-scope="scope">
            <div class="scopeOperate" @click="openInnerDialog(scope.row)">
              {{ scope.row.operate }}
            </div>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination background layout="prev, pager, next" :current-page="pageNum" :page-size="pageSize"
          :total="filteredData.length" @current-change="handlePageChange" />
      </div>

      <el-dialog :show-close="false" :visible.sync="innerVisible" append-to-body>
        <div class="details-box">
          <div class="details-content">
            <div class="details-img-box">
              <img class="details-img" src="@/assets/image/details.png" />
            </div>
            <div class="details-box-title">
              <div class="details-title">工单详情</div>
              <div class="details-text">查看并处理当前的导出请求</div>
            </div>
          </div>
          <i class="el-icon-close" v-if="innerVisible" @click="details" style="cursor: pointer; font-size: 25px" />
        </div>
        <div style="padding: 0 32px; box-sizing: border-box">
          <div class="apply-box">
            <div class="apply-content">
              <img class="apply-img" :src="currentWorkOrder?.customerAvatar" />
              <div class="apply-people">
                <div class="people-text">申请人</div>
                <div class="people-name">{{ currentWorkOrder?.customerNickName }}</div>
              </div>
            </div>
            <div>
              <div class="serial-num">工单编号</div>
              <div class="serial-number">{{ currentWorkOrder?.ticketNo || currentWorkOrder?.customerId }}</div>
            </div>
          </div>
          <div class="surface-box">
            <i class="el-icon-warning-outline surface-iaon" />
            <div>
              <div class="surface-title">请求内容:</div>
              <div class="surface-text">{{ currentWorkOrder?.description }}</div>
            </div>
          </div>
          <div class="illustrate-box">
            <div class="illustrate-title">详细说明</div>
            <div class="illustrate-text">
              {{ currentWorkOrder?.requestContent }}
            </div>
          </div>
          <div class="status-display-box">
            <div class="status-dot" :class="getStatusDotClass(processedWorkOrder?.status)"></div>
            <div class="illustrate-state" :class="getStatusTextClass(processedWorkOrder?.status)">
              {{ processedWorkOrder?.status }}
            </div>
          </div>
        </div>
        <div class="apply-btn-box">
          <div class="apply-btn-text" :class="{ 'btn-disabled': currentWorkOrder?.status !== 2 }"
            @click="handleExportClick">导出</div>
        </div>
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
import Api from "../api/index.js";

const apiInstance = new Api();

const STATUS_LABEL_MAP = {
  pending: "待审批",
  approved: "已通过",
  rejected: "已拒绝"
};

const STATUS_CLASS_MAP = {
  待审批: "status-pending",
  已通过: "status-approved",
  已拒绝: "status-rejected"
};

const STATUS_TEXT_MAP = {
  1: "待审批",
  2: "已通过",
  3: "已拒绝",
  待审批: "待审批",
  已通过: "已通过",
  已拒绝: "已拒绝"
};

const WORK_ORDER_TYPES = [
  { label: "全部工单", value: "all" },
  { label: "待审批", value: "pending" },
  { label: "已通过", value: "approved" },
  { label: "已拒绝", value: "rejected" }
];

function formatDate(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

function getDefaultDateRange() {
  const now = new Date();
  return [formatDate(new Date(now.getFullYear(), now.getMonth(), 1)), formatDate(now)];
}

function getRangeByType(type) {
  const now = new Date();
  const start = new Date(now);
  if (type === "30d") start.setDate(now.getDate() - 30);
  if (type === "90d") start.setDate(now.getDate() - 90);
  if (type === "1y") start.setFullYear(now.getFullYear() - 1);
  return [formatDate(start), formatDate(now)];
}

function getNextDate(dateStr) {
  const date = new Date(dateStr);
  date.setDate(date.getDate() + 1);
  return formatDate(date);
}

function includesValue(source, keyword) {
  if (!keyword) return true;
  return String(source || "").includes(keyword);
}

export default {
  name: "customers",

  data() {
    return {
      userName: "",
      /** 仅点击「搜索」后用于接口与列表筛选；输入框改动不触发请求 */
      appliedUserName: "",
      appliedShowNickName: "",
      customerTableLoading: false,
      searchInput: "",
      pageNum: 1,
      pageSize: 5,
      showNickName: "",
      customerPageNum: 1,
      customerPageSize: 10,
      timeRange: "30d",
      outerVisible: false,
      innerVisible: false,
      activeWorkOrder: "all",
      currentWorkOrder: null,
      workOrderTypes: WORK_ORDER_TYPES,
      dateRange: getDefaultDateRange(),
      dialogDateRange: getDefaultDateRange(),
      exportList: false,
      exportTextarea: "",
      exportVisitorId: null,
      requestType: 1,
      pickerOptions: {
        disabledDate: (time) => time.getTime() > Date.now()
      },
      allTableData: [],
      tableData: [],
      customerTotal: 0
    };
  },

  created() {
    this.customerList();
  },

  computed: {
    filteredCustomerData() {
      let data = this.tableData;
      const parseTime = (value) => {
        if (!value) return NaN;
        return new Date(String(value).replace(/-/g, "/")).getTime();
      };
      // 1. 姓名筛选（以搜索确认后的条件为准）
      if (this.appliedUserName) {
        data = data.filter((item) => includesValue(item.name, this.appliedUserName) || includesValue(item.nickname, this.appliedUserName));
      }
      // 2. 备注筛选
      if (this.appliedShowNickName) {
        data = data.filter((item) => includesValue(item.showNickName, this.appliedShowNickName));
      }
      // 3. 日期范围筛选
      if (this.dateRange && this.dateRange.length === 2) {
        const startTime = parseTime(`${this.dateRange[0]} 00:00:00`);
        const endTime = parseTime(`${this.dateRange[1]} 23:59:59`);
        data = data.filter((item) => {
          const itemTime = parseTime(item.creationDate);
          if (isNaN(itemTime)) return false;
          return itemTime >= startTime && itemTime <= endTime;
        });
      }
      return data;
    },

    filteredData() {
      let data = this.allTableData;
      if (this.activeWorkOrder !== "all") {
        const statusText = STATUS_LABEL_MAP[this.activeWorkOrder];
        data = data.filter((item) => item.status === statusText);
      }
      if (this.searchInput) {
        data = data.filter((item) => includesValue(item.serialNumber, this.searchInput));
      }
      return data;
    },

    pagedData() {
      const start = (this.pageNum - 1) * this.pageSize;
      return this.filteredData.slice(start, start + this.pageSize);
    },

    pagedTableData() {
      return this.filteredCustomerData;
    },

    pageInfoText() {
      const total = this.customerTotal;
      if (!total) return "共 0 位客户";
      const start = (this.customerPageNum - 1) * this.customerPageSize + 1;
      const end = Math.min(this.customerPageNum * this.customerPageSize, total);
      return `显示 ${start} 至 ${end} 条, 共 ${total} 位客户`;
    },

    totalCustomerText() {
      return `客户总数: ${Number(this.customerTotal || 0).toLocaleString()}`;
    },

    processedWorkOrder() {
      if (!this.currentWorkOrder) return null;
      return {
        ...this.currentWorkOrder,
        status: this.mapStatus(this.currentWorkOrder.status)
      };
    }
  },

  watch: {
    timeRange(value) {
      this.dateRange = getRangeByType(value);
      this.customerPageNum = 1;
      this.customerList();
    },

    // userName: "handleCustomerSearch",
    // showNickName: "handleCustomerSearch",

    outerVisible(value) {
      if (value) this.pageNum = 1;
    },

    searchInput() {
      this.pageNum = 1;
    },

    activeWorkOrder() {
      this.pageNum = 1;
    },

    dialogDateRange() {
      this.pageNum = 1;
      if (this.outerVisible) this.showHistory();
    }
  },

  methods: {
    handleCustomerSearch() {
      this.appliedUserName = this.userName.trim();
      this.appliedShowNickName = typeof this.showNickName === "string" ? this.showNickName.trim() : this.showNickName;
      this.customerPageNum = 1;
      this.customerList();
    },

    handleCustomerReset() {
      this.userName = "";
      this.showNickName = "";
      this.appliedUserName = "";
      this.appliedShowNickName = "";
      this.timeRange = "30d";
      this.dateRange = getRangeByType("30d");
      this.customerPageNum = 1;
      this.customerList();
    },

    buildCustomerListParams() {
      const params = {
        pageNum: this.customerPageNum,
        pageSize: this.customerPageSize,
        nickName: this.appliedUserName,
        userName: this.appliedUserName,
        showNickName: this.appliedShowNickName
      };
      if (this.dateRange && this.dateRange.length === 2) {
        params.startTime = this.dateRange[0];
        params.endTime = getNextDate(this.dateRange[1]);
      }
      return params;
    },

    mapCustomer(item) {
      return {
        id: item.id,
        nickID: item.id || "-",
        online: item.online === true,
        nickname: item.nickName || "-",
        fettle: item.online ? "活跃" : "未活跃",
        name: item.nickName || item.userName || "-",
        showNickName: item.showNickName || "_",
        creationDate: item.createdTime || item.createTime || "-"
      };
    },

    async customerList() {
      this.customerTableLoading = true;
      try {
        const res = await apiInstance.visitorList(this.buildCustomerListParams());
        const data = res?.data || res || {};
        const rows = data.rows || data.list || data.records || data.items || [];
        this.tableData = Array.isArray(rows) ? rows.map(this.mapCustomer) : [];
        this.customerTotal = Number(data.total ?? data.count ?? this.tableData.length);
      } catch (error) {
        console.error("获取客户列表失败:", error);
        this.$message.error("客户数据加载失败");
        this.tableData = [];
        this.customerTotal = 0;
      } finally {
        this.customerTableLoading = false;
      }
    },

    handleCustomerPageChange(page) {
      this.customerPageNum = page;
      this.customerList();
    },

    exportHistory(visitorId) {
      this.exportVisitorId = visitorId || null;
      this.exportList = true;
    },

    closureDialog() {
      this.exportList = false;
      this.exportTextarea = "";
      this.exportVisitorId = null;
    },

    async ExportConfirm() {
      const description = (this.exportTextarea || "").trim();
      if (!description) {
        this.$message.warning("请输入请求说明");
        return;
      }
      const visitorId = this.exportVisitorId ? [this.exportVisitorId] : [];
      try {
        await apiInstance.apply({
          visitorId,
          requestType: this.requestType,
          description
        });

        this.$message.success("申请已提交");
        this.closureDialog();
      } catch (error) {
        console.error("导出申请失败:", error);
        this.$message.error("申请提交失败");
      }
    },

    mapStatus(status) {
      return STATUS_TEXT_MAP[status] || "待审批";
    },

    mapWorkOrder(item) {
      const status = this.mapStatus(item.status);
      return {
        ...item,
        id: item.id,
        name: item.customerNickName || "-",
        serialNumber: item.ticketNo || item.customerId || "-",
        text: item.requestContent || item.description || "-",
        time: item.createTime || item.createdTime || "-",
        description: item.description || "-",
        status,
        btn: status,
        operate: "查看详情"
      };
    },

    async showHistory() {
      this.outerVisible = true;
      try {
        const params = {
          requestType: this.requestType
        };
        if (this.dialogDateRange && this.dialogDateRange.length === 2) {
          params.startTime = this.dialogDateRange[0];
          params.endTime = getNextDate(this.dialogDateRange[1]);
        }
        const res = await apiInstance.history(params);
        const rows = res?.data?.rows || res?.rows || res?.data || [];
        this.allTableData = Array.isArray(rows) ? rows.map(this.mapWorkOrder) : [];
      } catch (error) {
        console.error("获取工单列表失败:", error);
        this.$message.error("工单数据加载失败");
        this.allTableData = [];
      }
    },

    closeHistory() {
      this.outerVisible = false;
    },

    setActiveWorkOrder(value) {
      this.activeWorkOrder = value;
    },

    async openInnerDialog(row) {
      if (!row || !row.id) {
        this.$message.error("工单ID不存在");
        return;
      }
      this.innerVisible = true;
      try {
        const res = await apiInstance.info(row.id);
        this.currentWorkOrder = res?.data || res || null;
      } catch (error) {
        console.error("获取工单详情失败:", error);
        this.$message.error("工单详情加载失败");
        this.currentWorkOrder = null;
      }
    },

    handlePageChange(page) {
      this.pageNum = page;
    },

    details() {
      this.innerVisible = false;
      this.currentWorkOrder = null;
    },

    getStatusClass(status) {
      return STATUS_CLASS_MAP[status] || "";
    },

    async handleExportClick() {
      if (this.currentWorkOrder?.status !== 2) return;
      const ticketId = this.currentWorkOrder.id;
      if (!ticketId) {
        this.$message.error("工单ID不存在");
        return;
      }
      try {
        const res = await apiInstance.export(ticketId);
        const blob = res instanceof Blob ? res : new Blob([res]);
        this.downloadExcel(blob, ticketId);
      } catch (error) {
        console.error("导出失败:", error);
        this.$message.error("导出失败");
      }
    },

    downloadExcel(blob, ticketId) {
      if (!blob) {
        this.$message.error("导出文件为空");
        return;
      }
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `客户报表_${ticketId}.xlsx`;
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
      }, 100);
    },

    getStatusDotClass(status) {
      if (status === "待审批") return "dot-pending";
      if (status === "已通过") return "dot-approved";
      if (status === "已拒绝") return "dot-rejected";
      return "";
    },

    getStatusTextClass(status) {
      if (status === "待审批") return "text-pending";
      if (status === "已通过") return "text-approved";
      if (status === "已拒绝") return "text-rejected";
      return "";
    }
  }
};
</script>

<style lang="scss" scoped>
.client-page {
  height: calc(100vh - 65px);
  padding: 20px;
  overflow: auto;
  background: #f2f3f5;
  box-sizing: border-box;

  .client-content,
  .stats-bar,
  .stats-content,
  .stats-line-box,
  .history-close,
  .close-box,
  .history-search,
  .work-order,
  .history-search-box,
  .pagination {
    display: flex;
    align-items: center;
  }

  .client-content,
  .stats-bar,
  .history-close,
  .history-search,
  .pagination {
    justify-content: space-between;
  }

  .iconDownload {
    font-size: 22px;
    cursor: pointer;
    color: #2764e6;
  }

  .stats-image-box {
    display: flex;
    align-items: center;
  }

  .stats-headImage {
    width: 32px;
    height: 32px;
    border: none;
    margin-right: 15px;
    border-radius: 12px;
  }

  .client-content {
    margin-bottom: 30px;

    .client-title {
      font-size: 20px;
      color: #191b23;
      font-weight: 400;
      margin-bottom: 2px;
      text-align: left;
    }

    .client-text {
      font-size: 14px;
      color: #434654;
      font-weight: 400;
    }

    .client-display {
      display: flex;
      align-items: center;

      .history-export {
        display: flex;
        align-items: center;
        padding: 8px 16px;
        border-radius: 4px;
        margin-left: 10px;
        cursor: pointer;
        box-sizing: border-box;
        border: 1px solid #e5e7eb;
        background: #ffffff;

        .export-text {
          font-size: 14px;
          color: #9b9b9b;
          margin-left: 10px;
        }
      }
    }
  }

  .iconTime {
    font-size: 20px;
    color: #9b9b9b;
  }

  .filter-data {
    .filter-box {
      width: 25%;
      padding: 16px;
      box-sizing: border-box;
      background: #ffffff;
      border-radius: 5px;
      margin-right: 20px;

      .filter-content {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .filter-title,
        .filter-btn {
          font-size: 12px;
        }

        .filter-title {
          color: #434654;
        }

        .filter-btn {
          color: #003da6;
          cursor: pointer;
        }
      }

      .filter-time,
      .filter-name,
      .filter-text {
        font-size: 12px;
        color: #6b7280;
        margin-top: 20px;
        text-align: left;
      }

      .filter-input {
        width: 100%;
        margin-top: 10px;
      }

      .filter-text {
        margin-bottom: 10px;
      }
    }

    .stats-bar-box {
      width: 73%;
      background: #ffffff;
      border-radius: 4px;
      padding-bottom: 10px;
      box-sizing: border-box;

      .stats-bar {
        padding: 15px 25px;
        box-sizing: border-box;

        .stats-img {
          width: 14px;
          height: 9px;
          margin-right: 5px;
        }

        .stats-icon {
          width: 14px;
          height: 12px;
          margin: 0 5px 0 20px;
        }

        .stats-text,
        .stats-image {
          font-size: 14px;
          color: #4b5563;
        }

        .stats-total {
          font-size: 12px;
          color: #9ca3af;
        }
      }

      .stats-nickname,
      .stats-showNickName,
      .creationDate {
        font-size: 16px;
      }

      .stats-nickname {
        color: #6b7280;
      }

      .stats-nickID {
        font-size: 12px;
        color: #9ca3af;
      }

      .stats-showNickName {
        color: #191b23;
      }

      .creationDate {
        color: #4b5563;
      }

      .stats-line-box {
        .stats-line {
          width: 6px;
          height: 6px;
          margin-right: 10px;
          border-radius: 50%;
        }

        .stats-fettle {
          font-size: 12px;
        }
      }
    }
  }

  .calendar-date-picker {
    width: 260px;
    font-size: 14px;
    color: #0058bc;
    border-radius: 4px;
    border: 1px solid #e5e7eb;
    cursor: pointer;
  }

  .history-close {
    border-bottom: 1px solid #f1f5f9;
    padding: 20px 0;
    box-sizing: border-box;
    margin-bottom: 20px;

    .close-icon {
      width: 22px;
      height: 22px;
      margin-right: 10px;
    }

    .close-title {
      font-size: 30px;
      color: #0f172a;
      font-weight: 400;
    }
  }

  .history-search {
    margin-bottom: 20px;

    .work-order {
      width: 435px;
      padding: 4px;
      box-sizing: border-box;
      background: #f1f5f9;
      border-radius: 4px;

      .work-order-title {
        flex: 1;
        font-size: 14px;
        color: #64748b;
        padding: 8px 0;
        text-align: center;
        cursor: pointer;
        transition: all 0.3s;

        &.workTitle {
          color: #0052d9;
          background-color: #ffffff;
          border-radius: 4px;
        }
      }
    }

    .history-search-box {
      .search-input {
        margin-left: 10px;
        border-radius: 4px;
        border: 1px solid #e2e8f0;
      }
    }
  }

  .pagination {
    padding: 20px 30px 10px;
    box-sizing: border-box;
  }

  .scopeOperate {
    color: #0052d9;
    font-size: 14px;
    cursor: pointer;
  }
}

.status-tag {
  width: 60px;
  height: 25px;
  line-height: 25px;
  font-size: 12px;
  border-radius: 12px;
  text-align: center;
  display: inline-block;
}

.status-online {
  background: #2ba471;
}

.status-offline {
  background: #f53f3f;
}

.text-online {
  color: #2ba471;
}

.text-offline {
  color: #f53f3f;
}

.status-pending {
  background-color: #dbeafe;
  color: #1d4ed8;
}

.status-approved {
  background-color: #86f2e4;
  color: #006f66;
}

.status-rejected {
  background-color: #ffdad6;
  color: #93000a;
}

.export-title {
  font-size: 14px;
  color: #374151;
  font-weight: bold;
  text-align: left;
  margin-bottom: 50px;
}

.export-txt {
  font-size: 12px;
  color: #374151;
  text-align: left;
  margin-bottom: 10px;
}

.filter-data,
.illustrateBox,
.details-box,
.details-content,
.details-img-box,
.apply-box,
.apply-content,
.surface-box,
.status-display-box,
.apply-btn-box {
  display: flex;
}

.illustrateBox,
.details-box,
.apply-box {
  align-items: center;
  justify-content: space-between;
}

.illustrateBox {
  margin-top: 30px;

  .illustrate-text {
    font-size: 14px;
    color: #000000;
  }
}

.details-box {
  padding: 30px 32px;
  box-sizing: border-box;
  margin-bottom: 30px;
  border-bottom: 1px solid #f1f5f9;

  .details-content {
    align-items: center;

    .details-img-box {
      width: 40px;
      height: 40px;
      border-radius: 4px;
      align-items: center;
      justify-content: center;
      background: #adc6ff;

      .details-img {
        width: 16px;
        height: 20px;
      }
    }

    .details-box-title {
      margin-left: 10px;

      .details-title {
        font-size: 16px;
        color: #0b1c30;
      }

      .details-text {
        font-size: 14px;
        color: #717786;
      }
    }
  }
}

.apply-box {
  padding: 25px;
  box-sizing: border-box;
  border: 1px solid #f1f5f9;
  border-radius: 8px;
  margin-bottom: 30px;

  .apply-content {
    align-items: center;

    .apply-img {
      width: 48px;
      height: 48px;
      border-radius: 12px;
    }

    .apply-people {
      margin-left: 10px;

      .people-text {
        font-size: 14px;
        color: #717786;
      }

      .people-name {
        font-size: 18px;
        color: #0b1c30;
      }
    }
  }

  .serial-num {
    font-size: 14px;
    color: #717786;
    text-align: right;
    margin-bottom: 5px;
  }

  .serial-number {
    font-size: 16px;
    color: #0070eb;
    text-align: center;
    border-radius: 12px;
    padding: 10px 20px;
    box-sizing: border-box;
    background: #d8e2ff4d;
  }
}

.surface-box {
  margin-bottom: 30px;

  .surface-iaon {
    font-size: 25px;
    color: #9e3d00;
    margin-right: 10px;
    margin-top: 3px;
  }

  .surface-title,
  .surface-text {
    font-size: 16px;
  }

  .surface-title {
    color: #0b1c30;
  }

  .surface-text {
    color: #414755;
  }
}

.illustrate-box {
  background: #e5eeff;
  padding: 25px;
  box-sizing: border-box;
  border-radius: 8px;
  border: 1px solid #c1c6d74d;
  margin-bottom: 30px;

  .illustrate-title {
    font-size: 16px;
    color: #717786;
    margin-bottom: 15px;
  }

  .illustrate-text {
    font-size: 16px;
    color: #0b1c30;
    margin-bottom: 15px;
  }
}

.status-display-box {
  align-items: center;
  margin-bottom: 30px;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 10px;
}

.dot-pending {
  background-color: #1d4ed8;
}

.text-pending {
  color: #1d4ed8;
}

.dot-approved {
  background-color: #006f66;
}

.text-approved {
  color: #006f66;
}

.dot-rejected {
  background-color: #93000a;
}

.text-rejected {
  color: #93000a;
}

.illustrate-state {
  font-size: 14px;
  margin-left: 10px;
}

.apply-btn-box {
  align-items: center;
  justify-content: flex-end;
  padding: 25px 32px;
  box-sizing: border-box;

  .apply-btn-text {
    width: 125px;
    height: 40px;
    color: #ffffff;
    line-height: 40px;
    background: #0052d9;
    border-radius: 8px;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s;

    &.btn-disabled {
      background-color: #cbd5e1 !important;
      color: #94a3b8 !important;
      cursor: pointer !important;
    }
  }
}

::v-deep(.el-range-input),
::v-deep(.el-range-separator) {
  color: #0058bc;
}

::v-deep .el-dialog__header {
  padding: 0 !important;
  box-sizing: border-box;
}

.el-input {
  width: 290px;
}

::v-deep .el-input__inner {
  border-radius: 4px;
}
</style>
